module.exports = __webpack_public_path__ + "static/media/logo-chinalco.30235660.jfif";